import { PageSEO } from "@/components/SEO";

const TermsPage = () => (
  <main data-testid="terms-page" className="pt-20">
    <PageSEO title="Terms & Conditions" description="Terms and conditions for using The Lemonade Living Company website, purchasing products, and accessing our services." path="/terms" />
    <section className="py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <p className="text-xs tracking-[0.3em] uppercase mb-4" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>Legal</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light mb-8" style={{ color: "var(--ll-text)" }}>Terms &amp; Conditions</h1>
        <p className="text-xs mb-12" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>Last updated: February 2026</p>

        <div className="space-y-8">
          <Section title="1. Introduction">
            Welcome to The Lemonade Living Company. By accessing our website and purchasing our products, you agree to be bound by these Terms and Conditions. Please read them carefully before making any purchase or using our services. If you do not agree to these terms, please do not use our website.
          </Section>

          <Section title="2. Products and Services">
            We offer digital wellness products (journals, planners, workbooks, prompt collections, trackers) and online courses. All digital products are delivered electronically via email or direct download after purchase. Physical products, where available, will be shipped to the address provided during checkout.
            {"\n\n"}
            Product descriptions and images are provided for illustrative purposes. We strive for accuracy but minor variations may occur in the final product.
          </Section>

          <Section title="3. Pricing and Payment">
            All prices are displayed in South African Rand (ZAR) and US Dollars (USD) based on your detected timezone. The final checkout amount is processed in ZAR through PayFast. Prices are subject to change without prior notice, but any changes will not affect orders already placed.
            {"\n\n"}
            Payment is processed securely through PayFast. By completing a purchase, you confirm that the payment details provided are accurate and that you are authorised to use the payment method.
          </Section>

          <Section title="4. Digital Product Delivery">
            Upon successful payment, digital products will be made available for immediate download and/or sent to the email address provided during checkout. It is your responsibility to provide a valid email address. We are not responsible for non-delivery due to incorrect email addresses, spam filters, or technical issues on your end.
          </Section>

          <Section title="5. Refund Policy">
            Due to the digital nature of our products, all sales are final once the product has been downloaded or the download link has been sent. We do not offer refunds for digital products that have been accessed.
            {"\n\n"}
            If you experience technical issues preventing you from accessing your purchase, please contact us within 7 days at lemonadeliving4me@gmail.com and we will work to resolve the issue.
            {"\n\n"}
            For physical products, refund requests may be submitted within 14 days of delivery if the product arrives damaged or defective.
          </Section>

          <Section title="6. Free Resources">
            We offer free resources in exchange for your name and email address. By downloading free resources, you consent to receiving the requested product via email. You may also receive occasional communications about related products. You can opt out of marketing communications at any time.
          </Section>

          <Section title="7. Course Access">
            Access to online courses is granted upon confirmed payment or valid beta access pass. Course content is for personal use only and may not be shared, redistributed, or resold. Beta access passes are time-limited and non-transferable.
          </Section>

          <Section title="8. Intellectual Property">
            All content on this website — including text, graphics, logos, product designs, course materials, and downloadable content — is the intellectual property of The Lemonade Living Company and is protected by South African and international copyright laws.
            {"\n\n"}
            You may use purchased products for personal, non-commercial purposes only. You may not reproduce, distribute, modify, or create derivative works from our products without written permission.
          </Section>

          <Section title="9. Limitation of Liability">
            Our products are designed to support your wellness journey and are not a substitute for professional medical, psychological, or psychiatric advice. If you are experiencing a mental health crisis, please contact a qualified healthcare professional or your local emergency services.
            {"\n\n"}
            The Lemonade Living Company shall not be liable for any indirect, incidental, or consequential damages arising from the use of our products or website.
          </Section>

          <Section title="10. User Conduct">
            You agree to use our website and products in a lawful manner. You may not use our platform to distribute harmful content, attempt to gain unauthorised access to our systems, or engage in any activity that disrupts our services.
          </Section>

          <Section title="11. Third-Party Services">
            Our website integrates with third-party services including PayFast (payments) and YouTube (course video hosting). Your use of these services is subject to their respective terms and privacy policies.
          </Section>

          <Section title="12. Governing Law">
            These terms are governed by and construed in accordance with the laws of the Republic of South Africa. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the South African courts.
          </Section>

          <Section title="13. Changes to These Terms">
            We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting to this page. Continued use of our website after changes constitutes acceptance of the revised terms.
          </Section>

          <Section title="14. Contact">
            For any questions regarding these Terms and Conditions, please contact:
            {"\n\n"}
            <strong>The Lemonade Living Company</strong>{"\n"}
            Email: lemonadeliving4me@gmail.com{"\n"}
            Location: South Africa
          </Section>
        </div>
      </div>
    </section>
  </main>
);

const Section = ({ title, children }) => (
  <div>
    <h2 className="font-serif text-lg font-medium mb-3" style={{ color: "var(--ll-text)" }}>{title}</h2>
    <p className="text-sm leading-relaxed whitespace-pre-line" style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}>
      {children}
    </p>
  </div>
);

export default TermsPage;
